import { CircularProgress } from "@mui/material";
import LoadingContext from "../../contexts/Loading";
import "./style.scss";

export default function Loading() {
  return (
    <LoadingContext.Consumer>
      {({ isLoading }) => {
        return (
          <div
            className={
              isLoading ? "loading-modal loading-opacity" : "loading-modal"
            }
          >
            <button
              className="loading-modal__overlay"
              onClick={(e) => e.stopPropagation()}
            />
            <div className="loading-modal__content">
              <div className="loading-modal__content__icon">
                <CircularProgress />
              </div>
              <div className="loading-modal__content__text">
                <p>Carregando...</p>
              </div>
            </div>
          </div>
        );
      }}
    </LoadingContext.Consumer>
  );
}
